import { Link } from 'react-router-dom';
import { brandLogo } from '../assets/menuImages';
import OptimizedImage from './OptimizedImage';

function Logo({ className = '' }) {
  return (
    <Link to="/" className={`brand-logo ${className}`} aria-label="DoWhile Food — Accueil">
      <OptimizedImage
        image={brandLogo}
        alt=""
        className="brand-logo-img"
        width={44}
        height={44}
      />
      <span className="brand-logo-text">
        <span className="brand-logo-top">
          <span className="brand-do">do</span>
          <span className="brand-while">while</span>
        </span>
        <span className="brand-logo-food">
          <span className="brand-logo-line" />
          FOOD
          <span className="brand-logo-line" />
        </span>
      </span>
    </Link>
  );
}

export default Logo;
